// components/ClientSchedulesDrawer/ScheduleList.jsx
import React from "react";
import { Box, Stack } from "@mui/material";
import ScheduleCard from "./ScheduleCard";
import ScheduleCardSkeleton from "./ScheduleCardSkeleton";

const ScheduleList = ({
  schedules,
  onView,
  onEditTime,
  onDelete,
  isAdmin,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Stack spacing={2}>
          {[1, 2, 3].map((item) => (
            <ScheduleCardSkeleton key={item} />
          ))}
        </Stack>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, overflow: "auto" }}>
      <Stack spacing={2}>
        {schedules?.map((job) => (
          <ScheduleCard
            key={job.id}
            job={job}
            onView={onView}
            onEditTime={onEditTime}
            onDelete={onDelete}
            isAdmin={isAdmin}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ScheduleList;